module.exports = __webpack_public_path__ + "notFile.svg?1e86efd1bf1738b95709183716aa8993";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/notFile.svg
// module id = 926
// module chunks = 2